module.exports = __webpack_public_path__ + "static/landing-cover-a27d31793e6d959fa84274ecaa1371e9.webm";